export default function joinUrlPath(...segments) {
  const normalizedSegments = segments
    .filter(segment => typeof segment === "string" && segment.length > 0)
    .map((segment, index) => {
      if (index === 0) {
        return segment.replace(/\/+$/, "");
      }

      return segment.replace(/^\/+|\/+$/g, "");
    })
    .filter(Boolean);

  return normalizedSegments.join("/");
}
